import React, { useState } from 'react'
import { LAST_SEARCH_KEY } from './constants'
import type { SearchHistoryType } from './searchHistory.types'
import SearchHistoryList from './SearchHistoryList'
import SearchHistoryEmptyState from './SearchHistoryEmptyState'

interface SearchHistoryProps {
  handleSubmit: (searchValue: string) => void
  compact?: boolean
}

const SearchHistory = ({
  handleSubmit,
  compact = false
}: SearchHistoryProps) => {
  const searchFromStorage = JSON.parse(localStorage.getItem(LAST_SEARCH_KEY))
  const [searchs, setSearchs] = useState<Array<SearchHistoryType>>(
    searchFromStorage || []
  )

  return (
    <>
      {searchs.length > 0 && (
        <SearchHistoryList
          handleSubmit={handleSubmit}
          searchs={searchs}
          setSearchs={setSearchs}
          compact={compact}
        />
      )}
      {searchs.length === 0 && <SearchHistoryEmptyState compact={compact} />}
    </>
  )
}

export default SearchHistory
